import { render, staticRenderFns } from "./dataAnalysisDetails.vue?vue&type=template&id=0ac0f706&scoped=true&"
import script from "./dataAnalysisDetails.vue?vue&type=script&lang=js&"
export * from "./dataAnalysisDetails.vue?vue&type=script&lang=js&"
import style0 from "./dataAnalysisDetails.vue?vue&type=style&index=0&id=0ac0f706&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac0f706",
  null
  
)

export default component.exports